import { axiosBBAuthClient } from "../api";

import { TokenRequestType } from "./types";

export const getToken = async (
  postData: TokenRequestType,
) => {
  const params = new URLSearchParams({
    ...postData,
  });

  const { data } = await axiosBBAuthClient({
    data: params,
    url: "/token",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return data;
};

export const getEndSession = async (tokenId: string) => {
  const { data } = await axiosBBAuthClient({
    url: `/connect/endsession?id_token_hint=${tokenId}`,
    method: "get",
  });

  return data;
};

export const getUserInfo = async (tokenId: string) => {
  const { data } = await axiosBBAuthClient({
    method: "get",
    url: "/userinfo",
    headers: {
      Authorization: `Bearer ${tokenId}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return data;
};
